/**
 * This constant determines the percentage of visible element eligible to
 * trigger the switch from solid header to transparent header.
 */
const IMMERSIVE_SECTION_VISIBILITY_THRESHOLD = 15;

if (!customElements.get('immersive-section')) {
  class ImmersiveSection extends HTMLElement {
    connectedCallback() {
      this._applyHeight();
      this._updateHeaderHeight();
      this._initHeaderObserver();

      this._resizeHandler = () => {
        this._updateHeaderHeight();
        if (this._isPrimaryHero) {
          this.style.marginTop = window.innerWidth >= 1024
            ? 'calc(-1 * var(--header-height))'
            : '';
        }
      };
      window.addEventListener('resize', this._resizeHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._resizeHandler);
      if (this._headerObserver) this._headerObserver.disconnect();
      
      const headerEl = document.querySelector('#shopify-section-header .header');
      if (headerEl) headerEl.classList.remove('header--over-immersive-section');

      document.body.classList.remove('immersive-section-first');
      this.style.marginTop = '';
    }

    _applyHeight() {
      const height = this.dataset.height;
      if (height) this.style.height = `${height}vh`;
    }

    _updateHeaderHeight() {
      const header = document.querySelector('#shopify-section-header');
      if (!header) return;
      const height = header.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    _initHeaderObserver() {
      const mainContent = document.getElementById('MainContent');
      if (!mainContent) return;

      const allImmersiveSections = Array.from(document.querySelectorAll('immersive-section'));
      const isFirst = allImmersiveSections[0] === this
        && this.getBoundingClientRect().top < 150;
      if (!isFirst) return;

      const headerEl = document.querySelector('#shopify-section-header .header');
      if (!headerEl) return;

      document.body.classList.add('immersive-section-first');
      this._isPrimaryHero = true;
      if (window.innerWidth >= 1024) {
        this.style.marginTop = 'calc(-1 * var(--header-height))';
      }

      const ratio = 1 - (IMMERSIVE_SECTION_VISIBILITY_THRESHOLD / 100);
      this._headerObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.intersectionRatio >= ratio) {
            headerEl.classList.remove('header--over-immersive-section');
          } else {
            headerEl.classList.add('header--over-immersive-section');
          }
        },
        { threshold: [0, ratio, 1] }
      );
      this._headerObserver.observe(this);
    }
  }

  customElements.define('immersive-section', ImmersiveSection);
}